<template>
  <div class="settings-form">
    <div class="form-group">
      <label class="form-label">Element ID</label>
      <input 
        :value="element.id"
        type="text"
        class="form-input"
        disabled
      />
      <p class="form-help-text">Unique identifier for this element</p>
    </div>

    <div class="form-group">
      <label class="form-label">Element Type</label>
      <input 
        :value="element.type || 'structure'"
        type="text"
        class="form-input"
        disabled
      />
    </div>

    <div v-if="element.type" class="form-group">
      <label class="form-label">Custom CSS Class</label>
      <input 
        v-model="localClass"
        type="text"
        class="form-input"
        placeholder="custom-class another-class"
        @input="emitUpdate"
      />
      <p class="form-help-text">Space-separated CSS classes</p>
    </div>
  </div>
</template>

<script setup>
import { ref, watch } from 'vue';

const props = defineProps({
  element: {
    type: Object,
    required: true
  }
});

const emit = defineEmits(['update']);

const localClass = ref(props.element.settings?.class || '');

watch(() => props.element, (newElement) => {
  localClass.value = newElement.settings?.class || '';
}, { deep: true });

function emitUpdate() {
  emit('update', { class: localClass.value });
}
</script>

<style scoped>
.form-help-text {
  margin-top: 4px;
  font-size: 12px;
  color: #6b7280;
}
</style>

